import React from 'react';
import { useScrollReveal, useCountUp } from '../hooks/useScrollReveal';
import './StatsCounter.css';

const StatCount = ({ end, suffix, label, href }) => {
  const [ref, count] = useCountUp(end || 0, 2000);
  const inner = (
    <>
      <span className="stats-counter__number">{count}{suffix}</span>
      <span className="stats-counter__label">{label}</span>
    </>
  );
  return href ? (
    <a className="stats-counter__item stats-counter__item--link" href={href} ref={ref}>{inner}</a>
  ) : (
    <div className="stats-counter__item" ref={ref}>{inner}</div>
  );
};

const StatLink = ({ label, sub, href, external }) => {
  const target = external ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <a className="stats-counter__item stats-counter__item--text stats-counter__item--link" href={href} {...target}>
      <span className="stats-counter__label">{label}</span>
      <span className="stats-counter__meta">{sub} →</span>
    </a>
  );
};

const StatsCounter = () => {
  const [ref, vis] = useScrollReveal();

  return (
    <section className="stats-counter" style={{
      backgroundImage: `linear-gradient(132deg, rgba(30, 34, 40, 0.92) 0%, rgba(50, 55, 60, 0.88) 55%, rgba(30, 34, 40, 0.94) 100%), url(${process.env.PUBLIC_URL}/assets/gallery/named/gallery-4.webp)`,
    }}>
      <div className="container">
        <div ref={ref} className={`stats-counter__content ${vis ? 'visible' : ''}`}>
          <div className="stats-counter__left">
            <p className="stats-counter__subtitle">Our Mission</p>
            <h2 className="stats-counter__title">
              Our mission is to empower individuals to unlock their highest potential, attain inner peace, and create a strong community of mental health professionals and hypnotherapists committed to transforming lives.
            </h2>
            <a href="/contact" className="btn-warm stats-counter__btn">
              Book An Appointment
            </a>
          </div>

          <div className="stats-counter__right">
            <div className="stats-counter__grid">
              <StatCount end={40} suffix="+" label="Years of Experience" />
              <StatCount end={4000} suffix="+" label="Clients Helped" href="/testimonials" />
              <StatLink label="Awards & Certificates" sub="View" href="/awards" />
              <StatLink label="Photo Gallery" sub="Browse" href="/gallery" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;
